/* 각종 애널리틱스 추적을 위한 결제데이터 */
export const useAnalyticsDataStore = defineStore(
  'analyticsData',
  () => {
    const checkoutItem = ref(<OptionPayData | AddonPayData | null>null)

    const setCheckoutItem = (data: OptionPayData | AddonPayData) => {
      checkoutItem.value = { ...data }
    }

    return {
      checkoutItem,
      setCheckoutItem,
      resetCheckoutItem: () => {
        checkoutItem.value = null
      }
    }
  },
  {
    persist: true // 네이버페이 결제시 refresh로 인해 추가
  }
)
